import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export const Card = ({ title, value, variation, invertTrendColor = false, comparativeSubtitle = "" }) => {
    const hasVariation = variation !== undefined && variation !== null && !Number.isNaN(Number(variation));
    const isPositive = Number(variation) >= 0;
    const isGood = invertTrendColor ? !isPositive : isPositive;

    return (
        <div className="card-dashboards">
            <div className="card-title-dashboards">{title}</div>
            <div className="card-value-dashboards">{value}</div>
            {hasVariation && (
                <div
                    className={`card-trend-dashboards ${
                        isGood ? 'card-trend-up-dashboards' : 'card-trend-down-dashboards'
                    }`}
                >
                    {isPositive ? (
                        <ArrowUpwardIcon fontSize="inherit" />
                    ) : (
                        <ArrowDownwardIcon fontSize="inherit" />
                    )}
                    <span>{Math.abs(Number(variation)).toFixed(2)}%</span>
                    {comparativeSubtitle && (
                        <span className="card-comparative-subtitle-dashboards">
                            {comparativeSubtitle}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};
